//import "./Location.css";
import CTASection from "./compon/CTASection";
import FAQ from "./compon/FAQ";
import HappinessGuarantee from "./compon/HappinessGuarantee";
import { LocHeader } from "./compon/LocHeader";
import TestimonialSection from "./compon/TestimonialSection";

export const Patna = (props) => {
  return (
    <div className="loc-section">
      <LocHeader />
   
      <CTASection />
      <HappinessGuarantee />
      <FAQ />
      <TestimonialSection />
    </div>
  );
}